if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',
    class ShopTheLook extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-shop-look-open]');
        this.drawer = this.querySelector('[data-shop-look-drawer]');
        this.panel = this.querySelector('.shop-look__panel');
        this.form = this.querySelector('[data-shop-look-form]');
        this.submitButton = this.form?.querySelector('[type="submit"]');
        this.status = this.querySelector('[data-shop-look-status]');
        this.selects = Array.from(this.querySelectorAll('[data-shop-look-variant]'));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (!this.trigger || !this.drawer || !this.panel || !this.form || !this.submitButton) return;

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.updateState = this.updateState.bind(this);

        this.trigger.addEventListener('click', this.open);
        this.querySelectorAll('[data-shop-look-close]').forEach((button) => button.addEventListener('click', this.close));
        this.selects.forEach((select) => select.addEventListener('change', this.updateState));
        this.form.addEventListener('submit', this.onSubmit);
        this.updateState();
      }

      disconnectedCallback() {
        document.removeEventListener('keyup', this.onKeyUp);
      }

      open() {
        this.drawer.hidden = false;
        this.drawer.classList.remove('is-closing');
        this.trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.drawer.classList.add('is-open');
            trapFocus(this.panel, this.querySelector('[data-shop-look-close]:not(.shop-look__overlay)'));
          });
        });
        document.addEventListener('keyup', this.onKeyUp);
      }

      close(event, restoreFocus = true, immediate = false) {
        if (event) event.preventDefault();
        this.drawer.classList.add('is-closing');
        this.drawer.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keyup', this.onKeyUp);
        removeTrapFocus(restoreFocus ? this.trigger : null);
        const closing = this.drawer;
        const hide = () => {
          if (!closing.classList.contains('is-open')) {
            closing.hidden = true;
            closing.classList.remove('is-closing');
          }
        };
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          hide();
          return;
        }
        window.setTimeout(hide, 600);
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() === 'ESCAPE') this.close(event);
      }

      updateState(event) {
        const ready = this.selects.length > 0 && this.selects.every((select) => select.value);
        this.submitButton.disabled = !ready;
        this.submitButton.setAttribute('aria-disabled', String(!ready));
        if (event?.type === 'change' && this.status) this.status.textContent = '';
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.submitButton.disabled) return;

        const items = this.selects.map((select) => ({ id: select.value, quantity: 1 }));
        const body = { items };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(this.trigger);
        }

        this.submitButton.disabled = true;
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner')?.classList.remove('hidden');
        if (this.status) this.status.textContent = 'Dodawanie stylizacji do koszyka…';

        try {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify(body);
          const response = await fetch(routes.cart_add_url, config);
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Nie udało się dodać stylizacji.');

          if (this.status) this.status.textContent = 'Stylizacja została dodana do koszyka.';
          if (this.cart) {
            this.close(null, false, true);
            this.cart.renderContents(result);
          } else {
            window.location = routes.cart_url;
          }
        } catch (error) {
          if (this.status) this.status.textContent = error.message || 'Nie udało się dodać stylizacji. Spróbuj ponownie.';
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('.loading__spinner')?.classList.add('hidden');
          this.updateState();
        }
      }
    },
  );
}

if (!customElements.get('mini-looks-page')) {
  customElements.define(
    'mini-looks-page',
    class MiniLooksPage extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-look-filter]'));
        this.rooms = Array.from(this.querySelectorAll('[data-look-room]'));
        this.cards = Array.from(this.querySelectorAll('[data-look-card]'));
        this.buttons.forEach((button) => button.addEventListener('click', () => this.filter(button)));
      }

      filter(button) {
        const value = button.dataset.lookFilter;
        this.buttons.forEach((candidate) => {
          const on = candidate === button;
          candidate.setAttribute('aria-pressed', String(on));
          candidate.classList.toggle('is-active', on);
        });
        this.rooms.forEach((room) => {
          room.hidden = value !== 'all' && room.dataset.capsuleHandle !== value;
        });
        this.cards.forEach((card) => {
          card.hidden = value !== 'all' && card.dataset.capsuleHandle !== value;
        });
        if (value === 'all') return;
        const room = this.rooms.find((candidate) => candidate.dataset.capsuleHandle === value && !candidate.hidden);
        room?.scrollIntoView({
          block: 'start',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
    },
  );
}
